import SignupPage from './pages/SignupPage'
import SigninPage from './pages/SigninPage'

export const AuthRoutes = [
  {
    path: '/signin',
    component: SigninPage
  },
  {
    path: '/signup',
    component: SignupPage
  }
]
